import CityPageTemplate from "../city-template/CityPageTemplate";
import { midlothianVaConfig } from "./data";

export default function MidlothianVaPage() {
  return <CityPageTemplate config={midlothianVaConfig} />;
}